import { TOGGLE_ACTION_PENDING } from './constants'

export const setRedirectUrl = () => {}
export const actionPending = payload => ({
  type: TOGGLE_ACTION_PENDING,
  isFetching: payload,
})



// WEBPACK FOOTER //
// ./services/ui-state/actions/index.js